module.exports = __webpack_public_path__ + "static/media/img-access-map-en-US.af703e91.jpg";